import { amber, blue, blueGrey, cyan, green, red } from "@mui/material/colors";

import { GeValueNotAvailable } from "../Components/General/GeneralIcons";
import React from "react";
import { hslToRgb } from "@mui/material/styles";
import moment from "moment";
import seedrandom from "seedrandom";

export const defaultDateFormat = "YYYY-MM-DD HH:mm";
export const defaultDateTimeFormat = "YYYY-MM-DD HH:mm:ss";

export const capitalize = (s) => {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
};

export const NotificationVariation = {
  COMPOUND: "compound",
  SIMPLE: "simple",
};

export const SegmentStatusColors = {
  Unset: blueGrey[400],
  Saved: amber[400],
  Approved: green[400],
  Edited: cyan[400],
  ApprovedEdition: blue[400],
};

export const ReferenceURLsStatusColors = {
  Total: blueGrey[400],
  Retry: amber[400],
  Reachable: green[400],
  NotReachable: red[400],
};

export default NotificationVariation;

export const valueOrNa = (
  value,
  onlyIcon = true,
  message = "Not available"
) => {
  if (value !== "" && value !== null && value !== undefined) return value;
  return onlyIcon ? (
    <GeValueNotAvailable
      titleAccess="Not Available"
      style={{ fontSize: "inherit" }}
    />
  ) : (
    <span style={{ fontStyle: "italic" }}>
      <GeValueNotAvailable
        titleAccess="Not Available"
        style={{ fontSize: "inherit", verticalAlign: "middle", marginRight: 4 }}
      />
      {message}
    </span>
  );
};

export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

export const formatText = (string) => {
  return string
    ? string.split("\n").map((item, key) => {
      return (
        <span key={key}>
          {item}
          <br />
        </span>
      );
    })
    : "";
};

const stripDiacritics = (string) => {
  return typeof string.normalize !== "undefined"
    ? string.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    : string;
};

const defaultStringifyOption = (option) => `${option.text}`;

export const optionsFilter = (options, inputValue, stringifyOption = null) => {
  const ignoreAccents = true;
  const ignoreCase = true;
  const limit = false;
  const matchFrom = "any";
  const stringify =
    stringifyOption === null ? defaultStringifyOption : stringifyOption;
  const trim = false;

  let input = trim ? inputValue.trim() : inputValue;
  if (ignoreCase) {
    input = input.toLowerCase();
  }
  if (ignoreAccents) {
    input = stripDiacritics(input);
  }

  const filteredOptions = options.filter((option) => {
    let candidate = stringify(option);
    if (ignoreCase) {
      candidate = candidate.toLowerCase();
    }
    if (ignoreAccents) {
      candidate = stripDiacritics(candidate);
    }

    return matchFrom === "start"
      ? candidate.indexOf(input) === 0
      : candidate.indexOf(input) > -1;
  });

  return typeof limit === "number"
    ? filteredOptions.slice(0, limit)
    : filteredOptions;
};

//golden ratio const
const PHI = 1.618033988749895;
export const generateColorFromString = (str) =>
  hslToRgb(
    `hsl(${Math.floor(((seedrandom(str)() + 1 / PHI) % 1) * 360)}, 50%, 50%)`
  );

export const generatePastelColor = () => {
  let R = Math.floor(Math.random() * 127 + 127);
  let G = Math.floor(Math.random() * 127 + 127);
  let B = Math.floor(Math.random() * 127 + 127);

  let rgb = (R << 16) + (G << 8) + B;
  return `#${rgb.toString(16)}`;
};

export const formatNumber = (value, longFormat = true) =>
  longFormat
    ? Intl.NumberFormat("en-Us").format(value)
    : Intl.NumberFormat("en-Us", {
      notation: "compact",
      compactDisplay: "short",
    }).format(value);

export const formatCurrency = (value, longFormat = true, currency = "USD") =>
  longFormat
    ? Intl.NumberFormat("en-Us", {
      style: "currency",
      currency: currency,
    }).format(value)
    : Intl.NumberFormat("en-Us", {
      notation: "compact",
      compactDisplay: "short",
      style: "currency",
      currency: currency,
    }).format(value);

export const formatCurrencyAlt = (value, longFormat = true, symbol = "$") =>
  longFormat
    ? symbol +
    " " +
    Intl.NumberFormat("en-Us", { minimumFractionDigits: 2 }).format(value)
    : symbol +
    " " +
    Intl.NumberFormat("en-Us", {
      notation: "compact",
      compactDisplay: "short",
      maximumSignificantDigits: 2,
    }).format(value);

moment.updateLocale("en", {
  week: {
    dow: 1,
  },
});
